/**
 * Русское числительное: выбор формы слова по числу.
 *
 * Правило полное, с исключением на 11–14: `11 мест`, а не `11 места`.
 * Инлайновые проверки вида `n < 5 ? 'места' : 'мест'`, встречающиеся
 * в проекте, на втором десятке дают неверную форму.
 *
 * @param {number} count - Число
 * @param {[string, string, string]} forms - [1 место, 2 места, 5 мест]
 * @returns {string} - Нужная форма слова, без самого числа
 */
export const plural = (count, forms) => {
  const n = Math.abs(count) % 100;
  const n1 = n % 10;

  if (n > 10 && n < 20) return forms[2];
  if (n1 > 1 && n1 < 5) return forms[1];
  if (n1 === 1) return forms[0];
  return forms[2];
};

/**
 * Число вместе с нужной формой слова: `2 места`, `11 мест`.
 */
export const pluralize = (count, forms) => `${count} ${plural(count, forms)}`;

export const PLACES = ['место', 'места', 'мест'];
